import { render, staticRenderFns } from "./ferramentasEditar.vue?vue&type=template&id=7a0d019f&scoped=true&"
import script from "./ferramentasEditar.vue?vue&type=script&lang=js&"
export * from "./ferramentasEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0d019f",
  null
  
)

export default component.exports